var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-show',{attrs:{"fields":_vm.fields,"resourceName":_vm.resourceName,"pk":_vm.pk,"breadcrumbs":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"actions.remove",fn:function(){return [(_vm.authAccountId === _vm.pk)?_c('span'):_vm._e()]},proxy:true},{key:"permission_all",fn:function(ref){
var input = ref.input;
return [_c('span',[_vm._v(" "+_vm._s(input === 1 ? "○" : "")+" ")])]}},{key:"permission_maker",fn:function(ref){
var input = ref.input;
return [_c('span',[_vm._v(" "+_vm._s(input === 1 ? "閲覧" : ( input === 2 ? "編集" : ""))+" ")])]}},{key:"permission_user",fn:function(ref){
var input = ref.input;
return [_c('span',[_vm._v(" "+_vm._s(input === 1 ? "閲覧" : ( input === 2 ? "編集" : ""))+" ")])]}},{key:"permission_article",fn:function(ref){
var input = ref.input;
return [_c('span',[_vm._v(" "+_vm._s(input === 1 ? "閲覧" : ( input === 2 ? "編集" : ""))+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }